// FETCH ALL PROPERTIES FROM SALES_ORDER_DETAILS PAGE
export const FETCH_SALES_ORDER_DETAILS_REQUEST = 'FETCH_SALES_ORDER_DETAILS_REQUEST';
export const FETCH_SALES_ORDER_DETAILS_SUCCESS = 'FETCH_SALES_ORDER_DETAILS_SUCCESS';
export const FETCH_SALES_ORDER_DETAILS_FAILURE = 'FETCH_SALES_ORDER_DETAILS_FAILURE';

// FETCH ALL PROPERTIES by ID FROM SALES_ORDER_DETAILS PAGE
export const FETCH_SALES_ORDER_DETAILS_BY_ID_REQUEST = 'FETCH_SALES_ORDER_DETAILS_BY_ID_REQUEST';
export const FETCH_SALES_ORDER_DETAILS_BY_ID_SUCCESS = 'FETCH_SALES_ORDER_DETAILS_BY_ID_SUCCESS';
export const FETCH_SALES_ORDER_DETAILS_BY_ID_FAILURE = 'FETCH_SALES_ORDER_DETAILS_BY_ID_FAILURE';

export const FETCH_STYLE_NUMBER_BY_SEASON_ID_REQUEST = 'FETCH_STYLE_NUMBER_BY_SEASON_ID_REQUEST';
export const FETCH_STYLE_NUMBER_BY_SEASON_ID_SUCCESS = 'FETCH_STYLE_NUMBER_BY_SEASON_ID_SUCCESS';
export const FETCH_STYLE_NUMBER_BY_SEASON_ID_FAILURE = 'FETCH_STYLE_NUMBER_BY_SEASON_ID_FAILURE';

export const FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_REQUEST = 'FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_REQUEST';
export const FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_SUCCESS = 'FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_SUCCESS';
export const FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_FAILURE = 'FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_FAILURE';

// FETCH ALL PROPERTIES by ID FROM SIZE_RATIO PAGE
export const FETCH_SIZE_RATIO_BY_ID_REQUEST = 'FETCH_SIZE_RATIO_BY_ID_REQUEST';
export const FETCH_SIZE_RATIO_BY_ID_SUCCESS = 'FETCH_SIZE_RATIO_BY_ID_SUCCESS';
export const FETCH_SIZE_RATIO_BY_ID_FAILURE = 'FETCH_SIZE_RATIO_BY_ID_FAILURE';

// CREATE PROPERTIES FOR SALES_ORDER_DETAILS PAGE
export const CREATE_SALES_ORDER_DETAILS_REQUEST = 'CREATE_SALES_ORDER_DETAILS_REQUEST';
export const CREATE_SALES_ORDER_DETAILS_SUCCESS = 'CREATE_SALES_ORDER_DETAILS_SUCCESS';
export const CREATE_SALES_ORDER_DETAILS_FAILURE = 'CREATE_SALES_ORDER_DETAILS_FAILURE';

// UPDATE PROPERTIES FOR SALES_ORDER_DETAILS PAGE
export const UPDATE_SALES_ORDER_DETAILS_REQUEST = 'UPDATE_SALES_ORDER_DETAILS_REQUEST';
export const UPDATE_SALES_ORDER_DETAILS_SUCCESS = 'UPDATE_SALES_ORDER_DETAILS_SUCCESS';
export const UPDATE_SALES_ORDER_DETAILS_FAILURE = 'UPDATE_SALES_ORDER_DETAILS_FAILURE';

// FETCH SINGLE PROPERTY FOR SALES_ORDER_DETAILS PAGE
export const FETCH_SINGLE_SALES_ORDER_DETAILS_REQUEST = 'FETCH_SINGLE_SALES_ORDER_DETAILS_REQUEST';
export const FETCH_SINGLE_SALES_ORDER_DETAILS_SUCCESS = 'FETCH_SINGLE_SALES_ORDER_DETAILS_SUCCESS';
export const FETCH_SINGLE_SALES_ORDER_DETAILS_FAILURE = 'FETCH_SINGLE_SALES_ORDER_DETAILS_FAILURE';

export const FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_REQUEST = 'FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_REQUEST';
export const FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_SUCCESS = 'FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_SUCCESS';
export const FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_FAILURE = 'FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_FAILURE';

// DELETE PROPERTIES FOR SALES_ORDER_DETAILS PAGE
export const DELETE_SALES_ORDER_DETAILS_REQUEST = 'DELETE_SALES_ORDER_DETAILS_REQUEST';
export const DELETE_SALES_ORDER_DETAILS_SUCCESS = 'DELETE_SALES_ORDER_DETAILS_SUCCESS';
export const DELETE_SALES_ORDER_DETAILS_FAILURE = 'DELETE_SALES_ORDER_DETAILS_FAILURE';

export const CREATE_USER_FORM_SALES_ORDER_DETAILS = 'CREATE_USER_FORM_SALES_ORDER_DETAILS';
export const CREATE_USER_FORM_SALES_ORDER_DETAILS_QUANTITY = 'CREATE_USER_FORM_SALES_ORDER_DETAILS_QUANTITY';
export const SALES_ORDER_DETAILS_USERFORM_RESET = 'SALES_ORDER_DETAILS_USERFORM_RESET';
export const SALES_ORDER_DETAILS_USERFORM_DROPDOWNLIST_RESET = 'SALES_ORDER_DETAILS_USERFORM_DROPDOWNLIST_RESET';

export const SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_REQUEST = 'SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_REQUEST';
export const SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_SUCCESS = 'SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_SUCCESS';
export const SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_FAILURE = 'SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_FAILURE';

export const SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_USERFORM_SAVING_REQUEST =
    'SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_USERFORM_SAVING_REQUEST';
export const SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_USERFORM_SAVING_SUCCESS =
    'SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_USERFORM_SAVING_SUCCESS';
export const SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_USERFORM_SAVING_FAILURE =
    'SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_USERFORM_SAVING_FAILURE';

export const SUB_STYLE_NUMBER_MULTI_DROPDOWN_REQUEST = 'SUB_STYLE_NUMBER_MULTI_DROPDOWN_REQUEST';
export const SUB_STYLE_NUMBER_MULTI_DROPDOWN_SUCCESS = 'SUB_STYLE_NUMBER_MULTI_DROPDOWN_SUCCESS';
export const SUB_STYLE_NUMBER_MULTI_DROPDOWN_FAILURE = 'SUB_STYLE_NUMBER_MULTI_DROPDOWN_FAILURE';

export const SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_REQUEST = 'SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_REQUEST';
export const SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_SUCCESS = 'SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_SUCCESS';
export const SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_FAILURE = 'SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_FAILURE';

export const SINGLE_SIZE_INFO_BY_ID_REQUEST = 'SINGLE_SIZE_INFO_BY_ID_REQUEST';
export const SINGLE_SIZE_INFO_BY_ID_SUCCESS = 'SINGLE_SIZE_INFO_BY_ID_SUCCESS';
export const SINGLE_SIZE_INFO_BY_ID_FAILURE = 'SINGLE_SIZE_INFO_BY_ID_FAILURE';

export const SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_REQUEST = 'SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_REQUEST';
export const SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_SUCCESS = 'SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_SUCCESS';
export const SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_FAILURE = 'SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_FAILURE';

export const SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_REQUEST = 'SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_REQUEST';
export const SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_SUCCESS = 'SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_SUCCESS';
export const SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_FAILURE = 'SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_FAILURE';


export const SALES_ORDER_DETAILS_CHECK_REQUEST = 'SALES_ORDER_DETAILS_CHECK_REQUEST';
export const SALES_ORDER_DETAILS_CHECK_SUCCESS = 'SALES_ORDER_DETAILS_CHECK_SUCCESS';
export const SALES_ORDER_DETAILS_CHECK_FAILURE = 'SALES_ORDER_DETAILS_CHECK_FAILURE';




export const SALES_ORDER_DETAILS_ADD_CHECK_REQUEST = 'SALES_ORDER_DETAILS_ADD_CHECK_REQUEST';
export const SALES_ORDER_DETAILS_ADD_CHECK_SUCCESS = 'SALES_ORDER_DETAILS_ADD_CHECK_SUCCESS';
export const SALES_ORDER_DETAILS_ADD_CHECK_FAILURE = 'SALES_ORDER_DETAILS_ADD_CHECK_FAILURE';

export const SALES_ORDER_DETAILS_EAN_CREATE_REQUEST = 'SALES_ORDER_DETAILS_EAN_CREATE_REQUEST';
export const SALES_ORDER_DETAILS_EAN_CREATE_SUCCESS = 'SALES_ORDER_DETAILS_EAN_CREATE_SUCCESS';
export const SALES_ORDER_DETAILS_EAN_CREATE_FAILURE = 'SALES_ORDER_DETAILS_EAN_CREATE_FAILURE';

export const RESET_SINGLE_SIZE_RATIO = 'RESET_SINGLE_SIZE_RATIO';
// navigate to access info page
export const NAVIGATE_SALES_ORDER = 'NAVIGATE_SALES_ORDER';

export const DROPDOWN_INPUT_GRID_DATA = 'DROPDOWN_INPUT_GRID_DATA';

export const DROPDOWN_INPUT_GRID_STYLE_MASTER_DATA = 'DROPDOWN_INPUT_GRID_STYLE_MASTER_DATA';

// navigate to access details page
export const NAVIGATE_SALES_ORDER_DETAILS = 'NAVIGATE_SALES_ORDER_DETAILS';
export const CHECK_FOR_GRID_CHANGES = 'CHECK_FOR_GRID_CHANGES';
export const CREATE_USER_FORM_EAN_NUMBER = 'CREATE_USER_FORM_EAN_NUMBER';
export const RESET_USER_FORM_EAN_NUMBER = 'RESET_USER_FORM_EAN_NUMBER';


// CREATE PROPERTIES FOR SALES_ORDER_DETAILS PAGE
export const CREATE_SALES_ORDER_DETAILS_EAN_REQUEST = 'CREATE_SALES_ORDER_DETAILS_EAN_REQUEST';
export const CREATE_SALES_ORDER_DETAILS_EAN_SUCCESS = 'CREATE_SALES_ORDER_DETAILS_EAN_SUCCESS';
export const CREATE_SALES_ORDER_DETAILS_EAN_FAILURE = 'CREATE_SALES_ORDER_DETAILS_EAN_FAILURE';


export const CREATE_SALES_ORDER_DETAILS_ADD_GRID_REQUEST = 'CREATE_SALES_ORDER_DETAILS_ADD_GRID_REQUEST';
export const CREATE_SALES_ORDER_DETAILS_ADD_GRID_SUCCESS = 'CREATE_SALES_ORDER_DETAILS_ADD_GRID_SUCCESS';
export const CREATE_SALES_ORDER_DETAILS_ADD_GRID_FAILURE = 'CREATE_SALES_ORDER_DETAILS_ADD_GRID_FAILURE';

export const SALES_ORDER_DETAILS_OVERALL_UPDATE_REQUEST = 'SALES_ORDER_DETAILS_OVERALL_UPDATE_REQUEST';
export const SALES_ORDER_DETAILS_OVERALL_UPDATE_SUCCESS = 'SALES_ORDER_DETAILS_OVERALL_UPDATE_SUCCESS';
export const SALES_ORDER_DETAILS_OVERALL_UPDATE_FAILURE = 'SALES_ORDER_DETAILS_OVERALL_UPDATE_FAILURE';

export const EDIT_MODAL_HEADER_DETAIL = 'EDIT_MODAL_HEADER_DETAIL'

export const SALES_ORDER_RESET_STYLE_GRID = 'SALES_ORDER_RESET_STYLE_GRID'

export const CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_REQUEST = 'CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_REQUEST';
export const CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_SUCCESS = 'CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_SUCCESS';
export const CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_FAILURE = 'CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_FAILURE';

export const STYLE_CODE_DETAILS_BULK_SINGLE_ROW_INSERT_REQUEST = 'STYLE_CODE_DETAILS_BULK_SINGLE_ROW_INSERT_REQUEST';
export const STYLE_CODE_DETAILS_BULK_SINGLE_ROW_INSERT_SUCCESS = 'STYLE_CODE_DETAILS_BULK_SINGLE_ROW_INSERT_SUCCESS';
export const STYLE_CODE_DETAILS_BULK_SINGLE_ROW_INSERT_FAILURE = 'STYLE_CODE_DETAILS_BULK_SINGLE_ROW_INSERT_FAILURE';